import type { ThemeTokens } from '../types';
import { tealLight } from './tealLight';

/**
 * Blue Light — spreads tealLight and overrides all brand + alpha tokens
 * with the blue (#2563eb) palette. Surface, text, shadow, and status tokens
 * are identical to tealLight.
 */
export const blueLight: ThemeTokens = {
  ...tealLight,
  id: 'blue-light',
  name: 'Blue Light',

  // Brand
  primaryColor:    '#2563eb',
  primaryLight:    '#3b82f6',
  primaryDark:     '#1d4ed8',
  primarySubtle:   '#e8f1fe',
  hoverColor:      '#e8f1fe',
  activeColor:     '#dbeafe',
  buttonFocusRing: 'rgba(37, 99, 235, 0.35)',
  shadowPrimary:   '0 4px 12px rgba(37, 99, 235, 0.25)',
  shadowPrimarySm: '0 1px 2px rgba(37, 99, 235, 0.20)',
  gradientBrand:   'linear-gradient(135deg, #2563eb 0%, #3a8d8d 100%)',
  gradientBrandR:  'linear-gradient(135deg, #3a8d8d 0%, #2563eb 100%)',
  gradientSubtle:  '#eff6ff',
  infoColor:       '#2563eb',

  // Brand alpha
  primaryAlpha12: 'rgba(37, 99, 235, 0.12)',
  primaryAlpha15: 'rgba(37, 99, 235, 0.15)',
  primaryAlpha18: 'rgba(37, 99, 235, 0.18)',
  primaryAlpha20: 'rgba(37, 99, 235, 0.20)',
  primaryAlpha25: 'rgba(37, 99, 235, 0.25)',
  primaryAlpha30: 'rgba(37, 99, 235, 0.30)',
  primaryAlpha35: 'rgba(37, 99, 235, 0.35)',
  primaryAlpha40: 'rgba(37, 99, 235, 0.40)',
};
